// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const selectAllPipMetrics = () => ({
    type: actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_METRICS
});

export const selectMetric = (metric, isSelected) => ({
    isSelected,
    metric,
    type: actions.SELECT_OPEN_PIP_PROGRAMS_REPORT_METRIC
});




// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/select-metric.js